import {
  array,
  bool,
  func,
  number,
  object,
  oneOfType,
  string,
} from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import ConnectedInlineApproval from '../../InlineApproval/ConnectedInlineApproval'
import ApproverControls from './ApproverControls'
import { shouldRenderInlineApproval } from './helpers'

import './styles.scss'

const WorkflowPanelApproval = ({
  attachmentId,
  comment,
  currentUser,
  entitySaveMethod,
  idx,
  isActive,
  isDirtyCheck,
  items,
  locked,
  onSetProxyApprover,
  people,
  phase,
  phaseId,
  proxyUser,
  remove,
  status,
  toUser,
  update,
  workflowLocation,
}) => {
  const approval = items[idx]
  const isProxyApproval =
    proxyUser &&
    !(Object.keys(proxyUser).length === 0 && proxyUser.constructor === Object)
  const willCompletePhase = () => {
    if (approval.isLastIncompleteItem) return true
    if (!phase.requires_all_approvals) return true
    if (phase.requires_all_approvals) {
      const pendingCount = phase.approvals.reduce((acc, obj) => {
        if (obj.status === 'pending') {
          return acc + 1
        }
        return acc
      }, 0)
      if (pendingCount === 1) return true
    }
    return false
  }

  return (
    <li
      className={kuiperClassNames(
        'workflow-panel-approval',
        `workflow-panel-approval-${status}`,
        {
          'is-proxyApprover': isProxyApproval,
          'with-comment': !!comment,
        }
      )}
    >
      <ApproverControls
        attachmentId={attachmentId}
        comment={comment}
        currentUser={currentUser}
        isActive={isActive}
        isProxyApproval={isProxyApproval}
        items={items}
        locked={locked}
        onSetProxyApprover={onSetProxyApprover}
        people={people}
        phase={phase}
        phaseId={phaseId}
        proxyUser={proxyUser}
        remove={remove}
        status={status}
        toUser={toUser}
        update={update}
        workflowLocation={workflowLocation}
      />

      {shouldRenderInlineApproval({
        currentUser,
        isActive,
        proxyUser,
        status,
        toUser,
      }) && (
        <ConnectedInlineApproval
          approval={approval}
          proxyUser={proxyUser}
          isDirtyCheck={isDirtyCheck}
          entitySaveMethod={entitySaveMethod}
          status={status}
          willCompletePhase={willCompletePhase()}
        />
      )}
    </li>
  )
}

WorkflowPanelApproval.propTypes = {
  attachmentId: oneOfType([string, number]),
  comment: string,
  currentUser: object,
  entitySaveMethod: func,
  idx: number,
  isActive: bool,
  isDirtyCheck: func,
  items: array,
  locked: bool,
  onSetProxyApprover: func,
  people: array,
  phase: object,
  phaseId: number,
  proxyUser: object,
  remove: func,
  status: string,
  toUser: object,
  update: func,
  workflowLocation: string,
}

export default WorkflowPanelApproval
